<template>
    <div>
        <div class="app-title">
            <em-view-title ref="viewTitle" :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                           :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                           :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"
                                           @showEntityMultipleModalSelect="$_emCommonModalMixin_showMultipleSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="mintalMesPrdIronOutputResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                      :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                      :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                      ref="emTable" exportDisabled :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template slot="left-header">
                                    <em-button
                                        type="process"
                                        class="btn btn-outline-primary btn-sm"
                                        customLabel="发起质检任务"
                                        :disabled="$_notCheckedOne"
                                        @click="$refs.normalInputEntitySelector.showModal()">
                                    </em-button>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
        <em-modal-normal-input-entity-selector ref="normalInputEntitySelector" entity="mintalMesQualityProject"
                                               @entityModalSelectSelected="submitInspectTask">
        </em-modal-normal-input-entity-selector>
    </div>
</template>
<script>
// Author Liang Gang Qiang
// Date 2021-11-01 15:27:59

import emCommonListMixin from "@/mixin/em/common/list";
import emCustomVuexMixin from "@/mixin/em/customVuex";
import EmModalNormalInputEntitySelector from "@/components/em/EmModal/NormalInputEntitySelector";
import emTableCheckedMixin from "@/mixin/em/common/stuffs/table/emTableCheckedMixin";

export default {
    name: "mintalMesPrdIronOutputListView",
    components: {EmModalNormalInputEntitySelector},
    mixins: [emCommonListMixin, emCustomVuexMixin, emTableCheckedMixin],
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        }
    },
    data() {
        return {
            newTaskLoading: false
        }
    },
    methods: {
        submitInspectTask(project) {
            this.newTaskLoading = true;
            this.$store.dispatch('api/put', {
                url: process.env.VUE_APP_MINTALMES_QUALITY_URL + "/mintalMesQualityProductionProject",
                entity: {
                    inspectType: 6,
                    inspectObject: this.selectIds,
                    qualityProjectId: project.id
                }
            }).then(() => {
                this.$message.success("Operation success");
            }).finally(() => this.newTaskLoading = false);
        }
    }
};
</script>